export function getPdfVoGarantieBadgeText (post, labels) {
  const libelle = (post.garantie_libelle || '').trim()
  const duration = post.garantie

  if (!libelle && !duration) {
    return ''
  }

  const { monthUnit, prefix } = labels
  const durationSuffix = duration ? ` ${duration} ${monthUnit}` : ''

  if (libelle) {
    const needsPrefix = !libelle.toLowerCase().includes(prefix.toLowerCase())
    const labelPart = needsPrefix ? `${prefix} ${libelle}` : libelle
    return `${labelPart}${durationSuffix}`
  }

  return `${prefix}${durationSuffix}`
}
